/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Container,
  Typography,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import PaymentAction from '../../../store/actions/PaymentAction';
import Loader from '../../../utils/errorPages/Loader';
import PaymentLoader from '../../../utils/errorPages/PaymentLoader';
import PaymentAuthorizeNet from './authoizeNet';
import PaymentStripe from './stripe';
import PaymentClover from './clover';
import Paypal from '../../../assets/images/paypal.png';
import Veem from '../../../assets/images/veem.png';

function PaymentIntegration() {
  const [payInfo, setPayInfo] = useState({});
  const { REACT_APP_API_URL } = process.env;

  const [clientInfo, setClientInfo] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { code, token } = useParams();

  const { paymentInfo, isLoading } = useSelector((state) => state.payment);

  useEffect(() => {
    dispatch(PaymentAction.getPaymentDatails(code, token, navigate));
  }, [dispatch]);

  useEffect(() => {
    const data = paymentInfo?.data || {};
    setPayInfo(data);
    setClientInfo(data?.client || {});
  }, [paymentInfo]);

  const renderClientInfo = (client) => {
    if (!client) return null;
    return (
      <>
        {client.name && <div>{client.name}</div>}
        {client.address_1 && <div>{client.address_1}</div>}
        <div>
          {client.address_2 && <span>{client.address_2}</span>}
          {client.city && <span>{client.city}</span>}
        </div>
        <div>
          {client.state && client.state.name && <span>{client.state.name}</span>}
          {client.country && client.country.name && <span>{client.country.name}</span>}
          {client.postal_code && <span> - {client.postal_code}</span>}
        </div>
        {client.email && <div>{client.email}</div>}
      </>
    );
  };

  console.log(loading, 'loading');

  return (
    <Container fixed>
      <Box sx={{ bgcolor: '#f9fafc', height: '100%', p: 5 }} className="cardWrapper">
        {isLoading ? <Loader /> : ''}
        <Card>
          <CardHeader
            sx={{ p: '24px!important' }}
            title={
              <Box>
                {payInfo?.address && payInfo?.address?.logo && (
                  <img
                    src={`${REACT_APP_API_URL}/${payInfo.address.logo}`}
                    alt="Velan Logo"
                    width="180"
                    height="45"
                  />
                )}
                <Typography variant="h2" component="h2" sx={{ mt: 1, fontSize: '25px !important' }}>
                  {payInfo?.address && payInfo?.address?.address_type}
                </Typography>
              </Box>
            }
            subheader={
              <Typography sx={{ whiteSpace: 'pre-line', mt: 1.2, color: '#888888 !important' }}>
                {payInfo?.address && payInfo?.address?.full_address}
              </Typography>
            }
          />
          <CardContent>
            <Typography variant="h2" component="h2" sx={{ mb: 2, fontSize: '25px !important' }}>
              Online Payment Form
            </Typography>
            <Grid container spacing={5}>
              <Grid item md={6} lg={6}>
                <Card
                  sx={{
                    height: '100%',
                    boxShadow: '0 0 10px 1px rgba(224, 224, 224, 1) !important'
                  }}
                >
                  <CardHeader title="Client Info" />
                  <CardContent>
                    <Typography variant="body1" component={Box}>
                      {renderClientInfo(payInfo?.client)}
                      {/* {payInfo?.client && payInfo?.client?.name}
                      <br />
                      {payInfo?.client && payInfo?.client?.address_1}
                      <br />
                      {payInfo?.client && payInfo?.client?.address_2}
                      {payInfo?.client && payInfo?.client?.address_2 && <br />}
                      {payInfo?.client && payInfo?.client?.city}
                      <br />
                      {payInfo?.client && payInfo?.client?.state && payInfo?.client?.state?.name}
                      <br />
                      {payInfo?.client &&
                        payInfo?.client?.country &&
                        payInfo?.client?.country?.name}{' '}
                      - {payInfo?.client && payInfo?.client?.postal_code}
                      <br />
                      {payInfo?.client && payInfo?.client?.email} */}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} lg={6}>
                <Card sx={{ boxShadow: '0 0 10px 1px rgba(224, 224, 224, 1)  !important' }}>
                  <CardHeader title="Invoice Details" />
                  <CardContent sx={{ p: '0px !important' }}>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Invoice Number
                            </TableCell>
                            <TableCell>{payInfo?.invoice_number || ''}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Invoice Date
                            </TableCell>
                            <TableCell>{payInfo?.invoice_date || ''}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Client Approval Date
                            </TableCell>
                            <TableCell>{payInfo?.client_approval_date || ''}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Payment Type
                            </TableCell>
                            <TableCell>{payInfo?.request_type_name || ''}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th" scope="row">
                              Invoice Amount
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="h2"
                                component="h2"
                                sx={{ mb: 2, fontWeight: 'bold', fontSize: '20px !important' }}
                              >
                                {`${payInfo?.currency_name || ''} ${payInfo?.grand_total || ''}`}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {paymentInfo && paymentInfo?.method === 'paypal' ? (
          <Card sx={{ mt: 2 }}>
            {loading ? <PaymentLoader /> : ''}
            <CardActions sx={{ justifyContent: 'center', py: '20px!important' }}>
              <Button
                className="save__btn"
                variant="text"
                sx={{
                  p: '0 !important',
                  minWidth: 'auto !important'
                }}
                color="secondary"
                onClick={() => {
                  dispatch(PaymentAction.generatePaypal(token, setLoading));
                }}
                disabled={loading}
                size="large"
              >
                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <img src={Paypal} alt="veem" width="" />
                )}
              </Button>
            </CardActions>
          </Card>
        ) : paymentInfo && paymentInfo?.method === 'veem' ? (
          <Card sx={{ mt: 2 }}>
            {loading ? <PaymentLoader /> : ''}
            <CardActions sx={{ justifyContent: 'center', py: '20px!important' }}>
              <Button
                className="save__btn"
                variant="text"
                sx={{
                  p: '0 !important',
                  minWidth: 'auto !important'
                }}
                color="secondary"
                onClick={() => {
                  dispatch(PaymentAction.generateVeem(token, setLoading));
                }}
                disabled={loading}
                size="large"
              >
                {loading ? <CircularProgress size={20} /> : <img src={Veem} alt="veem" width="" />}
              </Button>
            </CardActions>
          </Card>
        ) : paymentInfo && paymentInfo?.method === 'authorize.net' ? (
          <PaymentAuthorizeNet clientinfo={clientInfo} code={token} />
        ) : paymentInfo && paymentInfo?.method === 'stripe' ? (
          <PaymentStripe clientinfo={clientInfo} code={token} />
        ) : paymentInfo && paymentInfo?.method === 'clover' ? (
          <PaymentClover clientinfo={clientInfo} code={token} />
        ) : (
          ''
        )}
      </Box>
    </Container>
  );
}

export default PaymentIntegration;
